// extracted by mini-css-extract-plugin
export default {"searchInput":"ZtA2mQ","largeHeight":"pp0dOO","smallerText":"grYIvA","searchFadeIn":"kIxJ8T"};